module.exports = __webpack_public_path__ + "img/PF.1c09f581.svg";